export default __webpack_public_path__ + "media/images/gallery/1-adae17481c12d5f4324574ba42fd2587.jpg";